import { useApi } from '@/api';
import {
  ActivityCard,
  Banner,
  EntityName,
  KpiCard,
  Page,
  PageSkeleton
} from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { Flex, Heading } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import HistoricTabs from './HistoricTabs';
import PortfolioDetails from './PortfolioDetails';
// @ts-ignore
import andromedaStructureImage from '@/assets/images/andromeda_structure.png';

const NumberedList = styled.ol`
  padding: inherit;
  list-style-position: inside;
  margin-top: ${(props) => props.theme.space['2xs']};
  margin-bottom: ${(props) => props.theme.space['3xs']};
`;

export default function RWAILKPage() {
  const { ilk } = useParams();
  const [data, error] = useApi({
    url: `/groups/rwa/ilks/${ilk}/`,
    queryParams: {
      days_ago: 1
    }
  });

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <Page
        title={
          <EntityName>
            <Flex gap="3xs" flexDirection="column">
              <Flex gap="3xs">
                <Heading size="1">{data.name}</Heading>
              </Flex>
              <Flex gap="3xs" color="muted">
                {data.ilk}
              </Flex>
            </Flex>
          </EntityName>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Total Debt"
            variant="dai"
            data={data}
            field="debt"
            options={{
              trend: true,
              valueOptions: {
                currencyValueOptions: {
                  currency: tokensMapping('DAI'),
                  iconSize: '3'
                }
              }
            }}
          />

          <KpiCard
            title="Debt Ceiling"
            data={data}
            variant="dai"
            field="line"
            options={{
              trend: true,
              notation: 'compact',
              valueOptions: {
                currencyValueOptions: {
                  currency: tokensMapping('DAI'),
                  iconSize: '3'
                }
              }
            }}
          />
        </Flex>
        {ilk === 'RWA015-A' ? (
          <Banner href={andromedaStructureImage}>
            The BlockTower Andromeda transaction is vault collateralized by
            short-term United States Treasuries, allocated uniformly to treasury
            bills with terms between zero and six months. The transaction is
            structured through the TACO foundation, a foundation company
            incorporated in the Cayman Islands in 2022. TACO Foundation has
            arrangements with a number of service providers to facilitate the
            purchases, sales, and custody of these treasuries, namely
            <NumberedList>
              <li>BlockTower as Arranger and Asset Manager,</li>
              <li>Ankura as Paying Agent,</li>
              <li>Coinbase and Galaxy as Exchange Agents, and</li>
              <li>
                ComputerShare, StoneX, and Customers Bank as banking partners
                and custodians.
              </li>
            </NumberedList>
          </Banner>
        ) : null}

        {ilk === 'RWA007-A' ? (
          <Banner>
            The Monetalis Clydesdale transaction is a vault collateralized by
            short-term United States Treasuries, allocated uniformly to treasury
            bills with terms between zero and six months. The transaction is
            structured through James Asset (PTC) Limited, a private trust
            company established in the British Virgin Islands in 2022. James
            Asset (PTC) Limited and its subsidiary trusts have arrangements with
            a number of service providers to facilitate the purchases, sales,
            and custody of these treasuries, namely
            <NumberedList>
              <li>Monetalis as Arranger and reporting agent,</li>
              <li>SHRM Group as trustee,</li>
              <li>Coinbase as Exchange Agent, and </li>
              <li>Bank Sygnum as banking partner and custodian.</li>
            </NumberedList>
          </Banner>
        ) : null}

        <HistoricTabs ilk={ilk} />

        <PortfolioDetails ilk={ilk} />

        <ActivityCard
          url={`/groups/rwa/ilks/${ilk}/activity/`}
          linkTo="activity"
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
